<template>
  <Menubar :model="menuItems">
    <template #end>
      <div class="flex align-items-center">
        <span class="mx-2">{{ mode ? "3D" : "2D" }}</span>
        <InputSwitch v-model="mode" />

        <span class="mx-2">Selection:</span>
        <Dropdown title="Choose an option from the dropdown" v-model="selectedMode" :options="selectModeOptions" optionLabel="label" optionValue="value"/>
        <FilterTree class="ml-2" v-if="enabledFilter" />
        <Button
          class="ml-4"
          icon="pi pi-cog"
          @click="openedSettings = !openedSettings"
        />
      </div>
    </template>
  </Menubar>
  <SettingsModal :show="openedSettings" />
  <input
    class="fileInput"
    type="file"
    ref="file"
    @change="loadNew"
    accept=".json, .xlsx"
  />
</template>

<script>
import Menubar from "primevue/menubar";
import Button from "primevue/button";
import SettingsModal from "../Modals/SettingsModal.vue";
import Dropdown from 'primevue/dropdown';
import FilterTree from "./FilterTree.vue";
import { mapActions } from "vuex";
const XLSX = require("xlsx");

import {gzipToJson, jsonToGzip} from "../../helpers/converters";
import InputSwitch from "primevue/inputswitch";
import { mapState, mapGetters } from "vuex/dist/vuex.cjs.js";
import { toRaw } from 'vue';

export default {
  name: "MenuBar",

  components: { Menubar, Button, SettingsModal, InputSwitch, FilterTree, Dropdown },

  computed: {
    ...mapState("general", ["json"]),
    ...mapGetters("settings", ["getSelectionMode", "enabledFilter"]),
  
    mode: {
      get() {
        return this.$route.name == "3D";
      },
      set(value) {
        this.changedMode(value);
      }
    },

    selectModeOptions() {
      if (this.mode) {
        return [
          { label: 'None', value: 'none'},
          { label: 'Single', value: 'single'},
          { label: 'Multiple', value: 'multiple'},
          { label: 'Area', value: 'area'},
        ];
      }
      return [
        { label: 'None', value: 'none'},
        { label: 'Single', value: 'single' },
        { label: 'Multiple', value: 'multiple' },
      ];
    }
  },

  methods: {
    ...mapActions("general", ["loadJson", "changeLoadingInfo", "setBackgroundImage"]),
    ...mapActions("settings", ["changeEditMode", "changeSelectionMode"]),

    exportExcel() {
      if (!this.workbook) {
        this.workbook = XLSX.utils.book_new();
        this.workbook.SheetNames.push("Sheet1");
      }

      const sheetName = this.workbook.SheetNames[0];
      
      const rawJson = toRaw(this.json);

      const dataToExport = rawJson.map((item) => {
        const newItem = { ...item };
        if (newItem.Pbi3DGeometry) {
          newItem.Pbi3DGeometry = jsonToGzip(newItem.Pbi3DGeometry);
        }
        if (newItem.Pbi2DGeometry) {
          const pbi2dgeo = JSON.parse(JSON.stringify(newItem.Pbi2DGeometry));
          pbi2dgeo.Points.forEach((point, index) => {
            pbi2dgeo.Points[index] = { Point: point.join(";") };
            // decoded.Points[index] = point.Point.split(";").map(Number);
          });
          newItem.Pbi2DGeometry = jsonToGzip(pbi2dgeo);
        }
        return newItem;
      });

      const newWorksheet = XLSX.utils.json_to_sheet(dataToExport);
      this.workbook.Sheets[sheetName] = newWorksheet;

      const wbout = XLSX.write(this.workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      const blob = new Blob([wbout], { type: 'application/octet-stream' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'exported_data.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    changedMode(val) {
      this.changeEditMode(false);
      if (val) {
        this.$router.replace({ name: "3D" });
      } else {
        this.$router.replace({ name: "2D" });
      }
    },

    loadFromFile(file) {
      let ext = file.name.split(".").at(-1);
      let vue = this;
      if (ext == "xlsx") {
        var reader = new FileReader();
        reader.onload = function (e) {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, { type: "array" });
          vue.workbook = workbook;
          let sheetName = workbook.SheetNames[0];
          let worksheet = workbook.Sheets[sheetName];
          let json = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
          vue.loadFromJson(json);

          // Image
          let sheetNameConfig = workbook.SheetNames[1];
          let worksheetConfig = workbook.Sheets[sheetNameConfig];
          let config = XLSX.utils.sheet_to_json(worksheetConfig);
          let base64Image = "";
          for (let index = 0; index < config.length; index++) {
            const underlay = config[index]["Underlay"];
            if (underlay) {
              base64Image += underlay;
            }
          }
          vue.$nextTick(() => {
            vue.setBackgroundImage(base64Image);
          });
          // vue.setBackgroundImage(base64Image);
        };
        reader.readAsArrayBuffer(file);
      } else if (ext == "json") {
        let reader = new FileReader();
        reader.onload = (e) => {
          let json = JSON.parse(e.target.result);
          vue.loadFromJson(json["Kobi Toolkit for Power BI"]);
        };
        reader.readAsText(file);
      }
    },

    loadFromJson(json) {
      this.changeLoadingInfo({text: "Loading...", value: 0});
      this.$nextTick(() => {
        let vue = this;
        let elements = [];
        let rand = Math.random().toString(36).substring(7);
        json.forEach((element, index) => {
          try {
            let tmp = { ...element, troisIndex: rand + index};
            if (element.Pbi3DGeometry) {
              let decoded = gzipToJson(element.Pbi3DGeometry);
              if (decoded) {
                tmp = { ...tmp, Pbi3DGeometry: decoded };
              }
            }
            if (element.Pbi2DGeometry) {
              let decoded = gzipToJson(element.Pbi2DGeometry);
              if (decoded) {
                decoded.Points.forEach((point, index) => {
                  decoded.Points[index] = point.Point.split(";").map(Number);
                });
                tmp = { ...tmp, Pbi2DGeometry: decoded };
              }
            }
            if (tmp.Pbi3DGeometry || tmp.Pbi2DGeometry) {
              elements.push(tmp);
            }
          } catch (err) {
            //
          }
        });
        vue.loadJson(elements);
      });
    },

    loadNew(event) {
      if (event.target.files.length == 0) return;
      this.changeLoadingInfo({ text: "Loading...", value: 0 });
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.loadFromFile(event.target.files[0]);
        });
      });
    },
  },

  
  watch: {
    selectedMode(val) {
      this.changeSelectionMode(val);
    },

    selectModeOptions(val) {
      const index = val.findIndex(x => x.value === this.selectedMode);
      if (index == -1) {
        this.selectedMode = val[0].value;
      }
    }
  },


  data() {
    return {
      openedSettings: false,
      workbook: null,
      selectedMode: 'multiple',
      menuItems: [
        {
          label: "File",
          icon: "pi pi-fw pi-file",
          items: [
            {
              label: "Import",
              icon: "pi pi-fw pi-upload",
              command: () => {
                this.$refs.file.click();
              },
            },
            {
              label: "Export",
              icon: "pi pi-fw pi-download",
              command: () => {
                this.exportExcel();
              },
            },
            {
              label: "Samples",
              icon: "pi pi-fw pi-book",
              items: [
                {
                  label: "Basic",
                  command: () => {
                    import("../../assets/samples/basic.js").then((module) =>
                      this.loadFromJson(module.default)
                    );
                  },
                },
                {
                  label: "Advanced-200",
                  command: () => {
                    import("../../assets/samples/advanced-200.js").then(
                      (module) => this.loadFromJson(module.default)
                    );
                  },
                },
              ],
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.p-menubar {
  border-radius: 0;
  height: 64px !important;
}
.fileInput {
  position: absolute;
  visibility: hidden;
  z-index: -1;
}
</style>